// Research Agent: de permanente geautomatiseerde testpersona van Pearson App.
// Aangemaakt 29 aug 2026 via Beheer (create-user + save-market + set-market-owners,
// audit in security_events). Eén bron voor elke RA-check in app, scripts en tests.
// De accountrij leeft in users, de markt in markten_registry ('Research'),
// metadata (versie, tools) in config onder RESEARCH_AGENT_META_KEY,
// afgeronde runs in test_runs (run_by = RESEARCH_AGENT_RUN_BY).

export const RESEARCH_AGENT_USER_ID = 'user-1788017205751-08a25cbf';
export const RESEARCH_AGENT_EMAIL = 'research-agent@pearsonpartners.nl';
export const RESEARCH_AGENT_NAME = 'Research Agent';
export const RESEARCH_AGENT_MARKET = 'Research';
export const RESEARCH_AGENT_META_KEY = 'research_agent_meta';
export const RESEARCH_AGENT_RUN_BY = 'research-agent';

export function isResearchAgentUser(u) {
  if (!u) return false;
  if (String(u.id || '') === RESEARCH_AGENT_USER_ID) return true;
  return String(u.email || '').toLowerCase() === RESEARCH_AGENT_EMAIL;
}
